export const API_SESSION = '/session';
export const API_LOGIN = '/login';
export const API_EMPLOYEE = '/employees';
export const GRAPHQL = '/graphql';
export const { REACT_APP_API_HOST } = process.env;
